<!-- 由 suu 创建于 2026-01-28 Friday -->
<!-- 获得新勋章弹窗 -->
<template>
  <div class="MemberMedalPop" v-if="curMedal && showMedalPop">
    <van-overlay :show="true" z-index="100" class-name="mgp-cent">
      <div class="pop-cent">
        <!-- <img
          class="bg"
          src="https://cdnvue.gymcity.com.cn/uploads/mem-medal-pop-bg"
          alt
        /> -->
        <!-- <img
        class="b-medal-bg"
        :src="`https://cdnvue.gymcity.com.cn/uploads/mem-medal-pop-type-${curMedal.type}`"
        alt
        /> -->
        <img
          class="b-bg26"
          src="https://cdnvue.gymcity.com.cn/uploads/medal26-pop-bg"
          alt
        />
        <img class="user-img" :src="user.heard_img" alt="" />
        <div class="user-name">{{ user.nickname }}</div>
        <img class="b-medal" :src="curMedal.pic" alt />
        <div class="title">
          恭喜你解锁【{{ curMedal.info }}】{{
            this.list.length > 1 ? `等${this.list.length}个` : ''
          }}勋章
        </div>
        <!-- <div class="desc">已有{{ curMedal.all_nums }}人解锁此勋章</div> -->
        <!-- <div class="btn user-btn" @click="onNext">确定</div> -->
        <div class="btn user-btn" @click="onToDetail">去查看</div>
        <img
          class="close"
          src="https://cdnvue.gymcity.com.cn/uploads/b9613ad5441024843dc083a522a19d9e.webp"
          alt=""
          @click="showMedalPop = false"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'MemberMedalPop',

  components: {},

  props: {
    user: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showMedalPop: true,
      curIndex: 0
    }
  },

  computed: {
    curMedal() {
      return this.list.length > 0 && this.curIndex !== -1
        ? this.list[this.curIndex]
        : null
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 勋章下一个
     */
    onNext() {
      this.curIndex++
      if (this.curIndex > this.list.length - 1) {
        this.curIndex = -1
        this.$emit('on-close')
      }
    },
    onToDetail() {
      this.showMedalPop = false
      this.$http.get(
        'member/index?a=shareLogPush',
        {
          from: '勋章入口点击量_弹窗',
          from_id: 20260620001
        },
        true
      )
      if (this.list.length <= 1) {
        this.$http._toVueH5Url(`medal-list?id=${this.curMedal.id}`)
      } else {
        this.$http._toVueH5Url('medal-list', 'push', '最近获得勋章')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.MemberMedalPop {
  display: flex;
  flex-direction: column;
  align-items: center;
  .mgp-cent {
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    .pop-cent {
      width: 100%;
      // height: 75%;
      position: relative;
      z-index: 100;
      display: flex;
      flex-direction: column;
      align-items: center;
      .bg {
        width: vw(750);
        height: vw(750);
        position: absolute;
        left: 0;
        top: vw(50);
        z-index: -2;
        animation: bgAnimation 12s linear infinite;
      }
      @keyframes bgAnimation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .b-medal-bg {
        width: vw(370);
        height: vw(370);
        position: absolute;
        left: 50%;
        top: vw(263);
        transform: translate(-50%, 0);
        z-index: -1;
      }
      .b-bg26 {
        width: vw(572);
        // height: vw(370);
        position: absolute;
        left: 50%;
        top: vw(-60);
        transform: translate(-50%, 0);
        z-index: -1;
      }
      .user-img {
        width: vw(120);
        height: vw(120);
        border-radius: 50%;
        border: vw(4) solid #fff;
        margin-top: vw(110);
      }
      .user-name {
        font-weight: 600;
        font-size: vw(30);
        color: #ffffff;
        margin-top: vw(12);
      }
      .b-medal {
        width: vw(392);
        height: vw(434);
        margin-top: vw(26);
        margin-bottom: vw(134);
      }
      .title {
        color: #fff;
        font-weight: 500;
        font-size: vw(32);
        // margin-bottom: vw(6);
      }
      .desc {
        color: #fff;
        font-size: vw(24);
        margin-bottom: vw(40);
      }
      .btn {
        width: vw(562);
        height: vw(96);
        background-color: #ff2270;
        border-radius: vw(99);
        font-size: vw(32);
        font-weight: 500;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        margin-top: vw(60);
      }
      .close {
        width: vw(40);
        margin-top: vw(30);
      }
    }
  }
}
</style>
